import React from 'react';
import PlayerMatchup from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup';
import { useSelector } from 'react-redux';
import { getContextData } from '@gameday/utils/selectors/getContextData';
import buildPlayerUrl from '@gameday/utils/buildPlayerUrl';

const PlayerMatchupComponent = (props) => {
    const { playerId, language, linkProps } = props;
    const getPlayerContextData = useSelector(getContextData);
    const { disablePlayerLinks, playerPageContext } = getPlayerContextData(playerId);
    let clonedLinkProps;
    const hasLink = !disablePlayerLinks && props?.linkProps;

    if (hasLink) {
        const url = buildPlayerUrl({ nameSlug: playerId, language, playerPageContext });
        clonedLinkProps = { ...linkProps };
        clonedLinkProps.url = url;
        clonedLinkProps.dataAttr = {
            'data-playerid': playerId,
            'data-url': url
        };
        clonedLinkProps.target = '_blank';
    }

    return <PlayerMatchup {...props} linkProps={clonedLinkProps || null} />;
};

export default PlayerMatchupComponent;
